import moment from 'moment';
import { getFormattedCurrencyWithIdealDenomination } from 'utils/number';
import { groupBy } from 'lodash';

export const dateFormatter = dateStr => moment(dateStr).format('MMM Do, YYYY');

export const colFormatters = {
	maxDate: dateFormatter,
	minDate: dateFormatter,
	binnedDate: dateFormatter,
	spend: (value, currencySymbol) =>
		`${currencySymbol}${getFormattedCurrencyWithIdealDenomination({
			value,
			isUnitSign: true,
			hideDecimals: false,
		})}`,
};

export const getCols = (transactions, selectedDimension) => {
	if (!transactions || !transactions.headers || !selectedDimension) {
		return [];
	}
	const groupedColumns = groupBy(transactions.headers, 'colName');
	const columns = [
		{
			align: 'left',
			title: selectedDimension.label,
			colName: 'value',
			sortIndex: groupedColumns.value[0].sortIndex,
			width: 300,
		},
		{
			align: 'right',
			title: 'Spend',
			colName: 'spend',
			sortIndex: groupedColumns.spend[0].sortIndex,
			width: 132,
		},
		{
			align: 'right',
			title: '# of transactions',
			colName: 'transactionsCount',
			sortIndex: groupedColumns.transactionsCount[0].sortIndex,
			width: 140,
		},
		{
			align: 'left',
			title: 'Time period',
			colName: 'period',
			sortIndex: groupedColumns.minDate[0].sortIndex,
			width: 200,
		},
		{
			align: 'left',
			title: 'Deletion date',
			colName: 'binnedDate',
			sortIndex: groupedColumns.binnedDate[0].sortIndex,
			width: 124,
		},
	];
	return columns;
};
